import { Component } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ConfigColumnDef } from './config-table.component';

@Component({
  selector: 'app-config-vehicle-type',
  template: `<app-config-table
    tableName="Vehicle Types"
    [columns]="columns"
    permissionKey="Config.Manage"
    [loadFn]="load"
    [createFn]="create"
    [updateFn]="update"
    [deactivateFn]="deactivate">
  </app-config-table>`,
})
export class VehicleTypeConfigComponent {
  columns: ConfigColumnDef[] = [
    { field: 'name',        label: 'Name',        type: 'text',     required: true, maxLength: 64 },
    { field: 'description', label: 'Description', type: 'textarea',                 maxLength: 255 },
    { field: 'sortOrder',   label: 'Sort',        type: 'number' },
  ];

  constructor(private http: HttpClient) {
    this.load       = () => this.http.get<any[]>('/api/config/vehicle-types');
    this.create     = (d: any) => this.http.post('/api/config/vehicle-types', d);
    this.update     = (id: any, d: any) => this.http.put(`/api/config/vehicle-types/${id}`, d);
    this.deactivate = (id: any) => this.http.delete<void>(`/api/config/vehicle-types/${id}`);
  }

  load!: () => Observable<any[]>;
  create!: (d: any) => Observable<any>;
  update!: (id: any, d: any) => Observable<any>;
  deactivate!: (id: any) => Observable<void>;
}
